<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <SearchTitle label='带教老师月度绩效考评审核' url='/achievement/teach/scorerecordchecklist'></SearchTitle>
      <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
        <!--begin: Search Form -->
        <div class="m-form m-form--label-align-right">
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">管理单元：</label>
              </div>
              <div class="m-form__control">
                <el-select v-model="condition.secretarysec" filterable placeholder="全部">
                  <el-option label="全部" value=""></el-option>
                  <el-option v-for="item in managesecOptions" :key="item.DictItemID" :label="item.DictItemName" :value="item.DictItemID">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">考核月份：</label>
              </div>
              <div class="m-form__control">
                <el-date-picker v-model="condition.cpidate" type="month" placeholder="考核月份" value-format="yyyy-MM">
                </el-date-picker>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
        </div>
        <div style="clear: both;"></div>
        <div class="m--margin-top-10 m--margin-bottom-10" style="width: 100%;text-align: center;float: initial;">
          <SearchButton :url='searchUrl' ref="btnSearch"></SearchButton>
          <el-button type="primary" icon="el-icon-search" @click="NoPut">未考评</el-button>
        </div>
        <!--end: Search Form -->
        <!--begin: Datatable -->
        <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
          <el-table v-loading="loading" :data="tableData" stripe style="width: 100%" size="medium">
            <el-table-column label="科室">
              <template slot-scope="scope">
                {{scope.row.SecName}}
              </template>
            </el-table-column>
            <el-table-column label="月度">
              <template slot-scope="scope">
                {{scope.row.CPIDate|formatDate}}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="150">
              <template slot-scope="scope">
                <el-button @click="Check(scope.row)" type="text" size="medium">审核</el-button>
              </template>
            </el-table-column>
          </el-table>
          <!--end: Datatable -->
          <div style="margin-top: 10px;text-align: center;" v-if="this.condition.recordCount > 0">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="condition.currentPage"
              :page-sizes="[2, 10, 20, 30, 40]" :page-size="condition.pageSize" layout="total, sizes, prev, pager, next, jumper"
              :total="condition.recordCount">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'TeachScoreRecordCheckList',
    data() {
      return {
        condition: {
          username: '',
          rolelevel: '',
          secid: '',
          cpitype: '2',
          section: '',
          cpidate: '',
          cpistatus: '2',
          token: '',
          pageSize: 10,
          currentPage: 1,
          recordCount: 0,
          firstSearch: true,
          secretarysec: ''
        },
        tableData: null,
        searchUrl: this.$utils.Url.zpgl + '/api/APICPI/List',
        loading: true,
        secOptions: [],
        managesecOptions: []
      }
    },
    filters: {
      formatDate(val) {
        var now = new Date(val)
        var y = now.getFullYear()
        var m = now.getMonth() + 1
        return y + '-' + (m < 10 ? '0' + m : m)
      }
    },
    methods: {
      // 调整每页显示数
      handleCurrentChange: function(val) {
        this.condition.firstSearch = false
        this.condition.currentPage = val
        this.$refs.btnSearch.Search()
      },
      // 分页操作
      handleSizeChange: function(val) {
        this.condition.firstSearch = false
        this.condition.pageSize = val
        this.condition.currentPage = 1
        this.$refs.btnSearch.Search()
      },
      Check: function(row) {
        this.$router.push({
          name: 'TeachScoreRecordCheck',
          params: {
            cid: row.CPICID,
            id: row.CPIID,
            secname: row.SecName,
            cpidate: row.CPIDate
          }
        })
      },
      LoadManageSec: function() {
        var args = {
          token: this.condition.token,
          username: this.condition.username,
          rolelevel: this.condition.rolelevel
        }
        var that = this
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIDictItem/ManageSecionList', args, function(data) {
          that.managesecOptions = data.Data
        }, null, null, null)
      },
      NoPut: function() {
        this.$router.push({
          name: 'TecNoPut'
        })
      }
    },
    mounted: function() {
      this.condition.token = sessionStorage.getItem('token')
      this.condition.username = sessionStorage.getItem('username')
      this.condition.rolelevel = sessionStorage.getItem('rolelevel')
      this.condition.secid = sessionStorage.getItem('secid')
      this.LoadManageSec()
      this.$refs.btnSearch.Search()
    }
  }
</script>

<style scoped="scoped">
  /deep/.el-input {
    width: 220px;
  }
</style>
